import React from 'react';
import Course from './Course';

export default React.createClass({
    propTypes: {
        data: React.PropTypes.object,
        homeCourse: React.PropTypes.bool,
        i18n: React.PropTypes.object,
        leadingCoursesUrl: React.PropTypes.string,
        courseDetailsUrl: React.PropTypes.string
    },
    render() {
        if (!this.props.data) {
            return (
                <div className="c-courses__course">
                    {this.props.i18n.noHomeCourse}
                </div>
            )
        } else {
            return (
                <div className="c-courses__course">
                    <Course
                        id={this.props.data.Id}
                        courseNumber={this.props.data.CourseNumber}
                        name={this.props.data.Name}
                        lastPlayed={this.props.data.LastPlayed}
                        homeCourse={this.props.homeCourse}
                        leadingCoursesUrl={this.props.leadingCoursesUrl}
                        leadingCoursesId={this.props.data.LeadingCoursesId}
                        courseInformationUrl={this.props.data.CourseInformationUrl}
                        courseDetailsUrl={this.props.courseDetailsUrl}
                    />
                </div>
            );
        }
    }
});
